import React from "react";
import CertificateGenerator from "./components/CertificateGenerator";
import "./App.css";

function App() {
  return (
    <div className="App">
      <CertificateGenerator />
    </div>
  );
}

export default App;
